import { DoseDispensingProductsListItemDto } from '@pharmac-extranet/extranet-api'
import { AlertIcon, CheckIcon, DownArrowIcon } from '@pharmac-extranet/shared'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { CatalogItemIcon } from './CatalogItemIcon'

type Props = {
  availability: DoseDispensingProductsListItemDto['availability']
}

export const CatalogItemAvailability = memo(({ availability }: Props) => {
  const { t } = useTranslation()

  return (
    <CatalogItemIcon>
      {availability === 'Available' && (
        <>
          <CheckIcon icon="checkCircle" />
          {t('medicines.available')}
        </>
      )}
      {availability === 'In short supply' && (
        <>
          <DownArrowIcon icon="arrowDownCircle" />
          {t('medicines.inShortSupply')}
        </>
      )}
      {availability === 'Out of stock' && (
        <>
          <AlertIcon icon="alertTriangle" />
          {t('medicines.outOfStock')}
        </>
      )}
      {availability === 'To be discontinued' && (
        <>
          <DownArrowIcon icon="arrowDownCircle" />
          {t('medicines.toBeDiscontinued')}
        </>
      )}
      {availability === 'Discontinued' && (
        <>
          <AlertIcon icon="alertTriangle" />
          {t('medicines.discontinued')}
        </>
      )}
    </CatalogItemIcon>
  )
})
